import React from 'react';
import './general.css';

const Footer = () => (
  <footer className="text-center mt-4 footer">
    <p>&copy; {new Date().getFullYear()} Cedric Nagata</p>
  </footer>
);

export default Footer;
